import Base from './Base';
import Basic from './Basic';
import Jwt from './Jwt';

export {
    Base,
    Basic,
    Jwt,
};

export default {
    Base,
    Basic,
    Jwt,
};
